'use strict';

function ctrl($stateProvider) {
    $stateProvider
        .state('landing.dash', {
            views: {
                "": {
                    template: require('../views/live.html'),
                    controller: 'live',
                    controllerAs: 'page'
                },
                "header": {
                    template: require('../../pages/views/main/header.html'),
                    controller: 'HeaderController',
                    controllerAs: 'header',
                },
            }
        })
        .state('landing.dash.live', {
            url: '/live',
            // controllerAs: 'page',
            data: {
                title: 'Live Connections Dash',
                daterange: false
            }
        })
}

ctrl.$inject = ['$stateProvider'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/landing/routes/live.js
 **/